var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10332",
    "data-name": "Group 10332",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.757,
    height: 28.76,
    viewBox: "0 0 28.757 28.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4104",
    "data-name": "Rectangle 4104",
    width: 28.757,
    height: 28.76,
    fill: "#030"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10331",
    "data-name": "Group 10331",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44444",
    "data-name": "Path 44444",
    d: "M27.577,28.76a8.039,8.039,0,0,1-.693-.548Q23.436,24.832,20,21.439a3.326,3.326,0,0,1-.231-.282c-.483.322-.914.632-1.366.907a11.939,11.939,0,0,1-4.75,1.648,11.706,11.706,0,0,1-7.169-1.265,11.594,11.594,0,0,1-6.3-8.581,11.281,11.281,0,0,1,2.3-9.151A11.789,11.789,0,0,1,10.075.183a11.746,11.746,0,0,1,7.616,1.181,11.561,11.561,0,0,1,6.258,8.175A11.454,11.454,0,0,1,21.31,19.606c-.06.072-.12.143-.179.216a.466.466,0,0,0-.035.076c.053.058.112.127.176.19q3.42,3.368,6.839,6.738c.235.232.431.5.646.754v.505a1.329,1.329,0,0,1-.674.674ZM22.333,11.824c-.025-.332-.039-.744-.089-1.152a9.537,9.537,0,0,0-1.713-4.45A10.1,10.1,0,0,0,13.836,2a10.189,10.189,0,0,0-3.957.09A10.2,10.2,0,0,0,3.024,7.3,9.831,9.831,0,0,0,1.9,12.486,9.6,9.6,0,0,0,2.715,15.9a9.956,9.956,0,0,0,4.248,4.708,10.175,10.175,0,0,0,7.2,1.162,9.874,9.874,0,0,0,4.968-2.555,9.964,9.964,0,0,0,3.2-7.39",
    transform: "translate(0 0)",
    fill: "#030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.e41cc298fd97729f8ed0a6a85cdb200e.svg";
export { ForwardRef as ReactComponent };